<app-header></app-header>
<div class="content small-head">



  <!-- mobile -->
  <ng-container *ngIf="isMobile;else desktop_content">
    <div>
      <span *ngIf="bookType !== 'KBW'; else kbw_content">
        <h3>{{'VideoTitle' | translate }}</h3>
      </span> 
      <ng-template #kbw_content>
        <h3>{{'KbwVideoTitle' | translate }}</h3>
      </ng-template>

      <div class="video-container-mob">
        <vg-player (onPlayerReady)="onPlayerReady($event)">
          <vg-controls [vgAutohide]="true" [vgAutohideTime]="3">
            <vg-play-pause vgFor="my-video"></vg-play-pause>
        </vg-controls>
          <video [vgMedia]="media" #media id="singleVideo" preload="auto" controls autoplay [attr.muted]="videoMuted ? '' : null" playsinline webkit-playsinline width="400" (click)="onVideoClick()" >
              <source
              *ngIf="video && videoType"
              [src]="video"
              [type]="videoType">
          </video>
      </vg-player>
      </div>
      <div class="btn-next">
        <button mat-raised-button color="primary" [disabled]="isDisabled ? true : null" (click)=onClick()>{{'NextBtn' | translate}}</button>
      </div>
    </div>
  </ng-container>

  <!-- desktop -->
  <ng-template #desktop_content>
    <mat-card class="info-card">

      <span *ngIf="bookType !== 'KBW'; else kbw_content">
        <h3>{{'VideoTitle' | translate }}</h3>
      </span> 
      <ng-template #kbw_content>
        <h3>{{'KbwVideoTitle' | translate }}</h3>
      </ng-template>

      <div class="video-container">
      <vg-player (onPlayerReady)="onPlayerReady($event)">
        <vg-controls [vgAutohide]="true" [vgAutohideTime]="3">
          <vg-play-pause vgFor="my-video"></vg-play-pause>
      </vg-controls>
        <video controls [vgMedia]="media" #media id="singleVideo" preload="auto" autoplay [attr.muted]="videoMuted ? '' : null" playsinline webkit-playsinline width="500" (click)="onVideoClick()" >
            <source
            *ngIf="video && videoType"
            [src]="video"
            [type]="videoType">
        </video>
    </vg-player>
  <h2></h2>
      </div>
      <div class="btn-next">
        <button mat-raised-button color="primary" [disabled]="isDisabled ? true : null" (click)=onClick()>{{'NextBtn' | translate}}</button>
      </div>
    </mat-card>
  </ng-template>
</div>

<div [hidden]="!testmode">
  <p style="font-weight: bold;" class="debug-info">Test mode - url from flexus:</p>
  <p class="debug-info">{{urlInfo}}</p>
  <p class="debug-info">
    <a
    [title]="'exam'"
    [routerLink]="['/exam']">
    Go to exam screen
  </a>
  </p>
</div>
